<template>
  <div ref="priceContainer">
    <v-select
      class="search-select-item"
      ref="priceSelect"
      item-text="name"
      :label="$t('ARTWORK.PRICE')"
      :items="[]"
      solo
      flat
      hide-details
      clearable
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="index === 0">{{ $t('ARTWORK.PRICE') }}</span>
      </template>

      <template v-slot:append>
        <v-icon
          v-if="filters.pricesSelected.price_min != null"
          @click="onPriceClear"
          size="19"
          style="margin-right: 12px;"
        >fas fa-times</v-icon>
        <v-icon class="mr-1">fas fa-angle-down</v-icon>
      </template>

      <template v-slot:no-data>
        <div :style="{maxWidth: `${priceContainerWidth}px`}">
          <price-slider :filters="filters" @click:apply="onClickApply" />
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import PriceSlider from "@/views/Search/Mobile/PriceSlider";

export default {
  props: ["filters", "loading"],

  components: {
    PriceSlider
  },

  data() {
    return {
      priceContainerWidth: 260,
      customPrice: { min: 0, max: 7500 }, // for custom price range
      priceRange: [0, 7500]
    };
  },

  watch: {
    "filters.pricesSelected": {
      deep: true,
      handler: function(val) {
        this.$emit("change");
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.priceContainer) {
        this.priceContainerWidth = this.$refs.priceContainer.clientWidth;
      }
    });
  },

  methods: {
    onClickApply() {
      console.log("onClickApply");
      // Blur the price select to hide the drop down.
      this.$refs.priceSelect.blur();
    },


    onPriceClear(e) {
      e.stopPropagation();
      this.filters.pricesSelected.price_min = null;
      this.filters.pricesSelected.price_max = null;
      this.$refs.priceSelect.blur();
    }
  }
};
</script>